export const baseApiUrl = 'https://eml.com.co/snf-api';
export const baseFrontUrl = 'https://sospechar-no-falla.eml.com.co';
// export const baseApiUrl = 'http://localhost/snf-api';
// export const baseFrontUrl = 'http://localhost:3000';